import { useState } from 'react';
import { cn } from '../../lib/cn';

type Props = { scenes?: string[] };

export function LifestyleStudioPanel({ scenes = [] }: Props) {
  const [selected, setSelected] = useState(scenes[0] ?? '');

  return (
    <div className="space-y-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Lifestyle Studio</p>
      <div className="flex flex-wrap gap-1">
        {scenes.map((scene) => (
          <button
            key={scene}
            type="button"
            onClick={() => setSelected(scene)}
            className={cn(
              'rounded-lg px-2 py-1 text-xs font-medium transition',
              selected === scene
                ? 'bg-brand-600 text-white'
                : 'border border-slate-200 text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-400',
            )}
          >
            {scene}
          </button>
        ))}
      </div>
      <div className="aspect-video rounded-lg border border-slate-200 bg-gradient-to-br from-slate-100 to-slate-200 dark:border-slate-700 dark:from-slate-800 dark:to-slate-900">
        <div className="flex h-full items-end p-3">
          <p className="text-xs font-medium text-slate-600 dark:text-slate-400">{selected} scene preview</p>
        </div>
      </div>
    </div>
  );
}
